import { useAuth } from '../../hooks/useAuth';
import { ROL_LABELS } from '../../lib/roles';

export function Topbar() {
  const { perfil, signOut } = useAuth();

  return (
    <header className="flex h-16 items-center justify-between border-b border-onyx/10 bg-white px-6">
      <div />
      <div className="flex items-center gap-4">
        {perfil && (
          <div className="text-right leading-tight">
            <p className="text-sm font-medium text-onyx">{perfil.nombre}</p>
            <p className="text-xs text-onyx/50">{ROL_LABELS[perfil.rol]}</p>
          </div>
        )}
        <button onClick={signOut} className="btn-secondary text-xs">
          Cerrar sesión
        </button>
      </div>
    </header>
  );
}
